module.exports = __webpack_public_path__ + "media/index2.9814c962.webm";